import api from '../../api'

const getDefaultState = () => {
  return {
    map: {},
    api: {},
    places: [],
    initDocomoMobaku: false,
    showDocomoMobaku: false
  }
}

const state = getDefaultState()

const getters = {
  getPlaces: (state) => state.places,
  getMap: (state) => state.map,
  getApi: (state) => state.api
}

const actions = {
  updateMap({ commit }, { map, api }) {
    commit('setMap', { map, api })
  },
  fetchPlaces({ commit, state, rootGetters }, word) {
    const center = rootGetters['map/getCenter']
    const service = new state.api.maps.places.PlacesService(state.map);
    const location = new state.api.maps.LatLng(center.lat, center.lng);

    const request = {
      location: location,
      radius: '500',
      query: word
    }

    service.textSearch(request, (results, status) => {
      if (status == state.api.maps.places.PlacesServiceStatus.OK) {
        commit('setPlaces', results.map(r => {
          return {
            name: r.name,
            address: r.formatted_address,
            location: {
              latitude: r.geometry.location.lat(),
              longitude: r.geometry.location.lng()
            },
            isGooglePlace: true,
            isEkispertPlace: false
          }
        }))
      }
    })
  },
  reset ({ commit }) {
    commit('resetState')
  },
  initDocomoMobaku({ commit }) {
    commit('initDocomoMobaku')
  },
  onDocomoMobaku({ commit }) {
    commit('onDocomoMobaku')
    return new Promise(() => {
      api.getAnalytics('mobaku', 'on')
    })
  },
  offDocomoMobaku({ commit }) {
    commit('offDocomoMobaku')
    return new Promise(() => {
      api.getAnalytics('mobaku', 'off')
    })
  },
  updateGeocode ({ dispatch }, location) {
    const geocoder = new state.api.maps.Geocoder
    geocoder.geocode({'location': location}, function(results, status) {
      if (status === state.api.maps.GeocoderStatus.OK) {
        let name = `${location.lat}, ${location.lng}`
        if (results[0]) {
          const a = results[0].formatted_address.split(' ')
          name = `${a[1]}` // ${a[1]} ${name}`
        }
        const place = {
          name: name,
          location: {
            latitude: location.lat,
            longitude: location.lng
          },
          isGeocode: true
        }
        dispatch('map/updateGooglePlaceMarker', place , { root: true })
        dispatch('drawer/openPlace', { place: place, full: false }, { root: true })
      } else {
        console.log('Geocoder failed due to: ' + status)
      }
    })
  }
}

const mutations = {
  setMap (state, { map, api }) {
    state.map = map
    state.api = api
  },
  setPlaces (state, results) {
    state.places = results
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  initDocomoMobaku(state) {
    //特に処理はしない
    console.log(state)
  },
  onDocomoMobaku(state) {
    if (!state.showDocomoMobaku) {
      state.showDocomoMobaku = true
      if (!state.initDocomoMobaku) {
        state.initDocomoMobaku = true
        window.mobakumap.init(state.map)
      } else {
        window.mobakumap.show()
      }
    }
  },
  offDocomoMobaku(state) {
    if (state.showDocomoMobaku) {
      state.showDocomoMobaku = false
      window.mobakumap.hide()
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
